import SuperUserOrgs from '@/components/superuser/SuperUserOrgs'
import auth from './../auth'

export default [
  {
    path: '/admin/su/',
    name: 'SuperUserOrgs',
    component: SuperUserOrgs,
    beforeEnter: auth.ifAuthenticated
  },
]
